export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14583.b86add4a.jpg";